export default function OriginStory() {
  return (
    <section className="w-full bg-background-100 py-24 md:py-32 px-6 md:px-10 lg:px-14">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1 reveal">
          <span className="text-xs tracking-[0.35em] uppercase text-accent-700">Chapter One</span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-primary-950 mt-4 mb-8 leading-tight">
            A story that began before <em>sunrise.</em>
          </h2>
          <p className="text-foreground-800 leading-relaxed mb-6 text-lg">
            Meridian started in a rented garage in 2011, with one cast-iron drum and a stubborn belief that coffee should taste
            like the place it came from — not the roast that hid it. Fifteen years later, the drum is bigger and the mornings
            still start at 4:47 a.m.
          </p>
          <p className="text-foreground-700 leading-relaxed mb-10">
            We visit every farm we buy from. We name the growers on every bag. And we still roast in small batches, because that&apos;s
            the only way we know how to protect the delicate notes that make a great cup unforgettable.
          </p>
          <a
            href="#about"
            className="inline-flex items-center gap-2 text-primary-900 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap border-b border-primary-900 pb-1 text-sm tracking-wide"
          >
            <span>Read our full story</span>
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2 reveal">
          <div className="relative">
            <div className="relative h-[420px] md:h-[600px] w-full overflow-hidden rounded-lg">
              <img
                src={`${import.meta.env.BASE_URL}localized/origin-story-hands-01.jpg`}
                alt="Hands holding freshly roasted beans"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="hidden md:block absolute -bottom-10 -left-10 bg-background-50 p-6 max-w-xs rounded-lg border border-background-200">
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={`${import.meta.env.BASE_URL}localized/founder-portrait-01.jpg`}
                  alt="Founder"
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <span className="block text-sm font-medium text-primary-950">Elias Thorne</span>
                  <span className="block text-xs text-foreground-600">Founder &amp; Head Roaster</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 italic leading-relaxed">
                &ldquo;Every batch is a conversation with the farmer who grew it.&rdquo;
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}